import { render, staticRenderFns } from "./PlayAudio.vue?vue&type=template&id=296cb749&"
import script from "./PlayAudio.vue?vue&type=script&lang=js&"
export * from "./PlayAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports